import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface AdversaryNameLinkProps {
	adversaryName: string
}

export function AdversaryNameLink(props: AdversaryNameLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('adversaries', props.adversaryName)
		}}>
			{props.adversaryName}
		</a>
	)
}
